import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import COPY from './footerCopy';
import getHelpLink from '../../../helpers/getHelpLink';

export default function getFooterLinks(languageCode: string) {
  const linkParams = { ut_source: 'captive_footer' };
  return [
    {
      text: t(COPY.help),
      href: getHelpLink(languageCode, {
        params: linkParams,
      }),
    },
    {
      text: t(COPY.termsOfUse),
      href: createURL('/mp/legal/terms-of-use/', linkParams),
    },
    {
      text: t(COPY.privacyPolicy),
      href: createURL('/mp/legal/privacy-policy/', linkParams),
    },
  ];
}
